import styled from 'styled-components'

export const CompanyItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`
